import React, { FC } from 'react';
import { SubHeader } from '../../../components/sub-header/SubHeader';
import { LawFirmActionSlider } from './LawFirmActionSlider';
import { Sticker } from '../../../components/sticker/Sticker';
import { SubHeaderContent } from '../../../components/sub-header/SubHeaderContent';

export const LawFirmSubHeader: FC = () => {
  return (
    <SubHeader classNames="hide_on--tablet" id="law-firm-sub-header">
      <SubHeaderContent>
        <Sticker anchor="add-watcher-law-firm" margin="law-firm-sub-header">
          {({ isVisible }) => <LawFirmActionSlider isVisible={isVisible} />}
        </Sticker>
      </SubHeaderContent>
    </SubHeader>
  );
};
